var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-22 16:36:21
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import WithRouter from '../../components/WithRouter';
import APIForm from '../../components/antd/APIForm';
import APITagListSearchSelect from '../../components/antd/APITagListSearchSelect';
import APICascader from '../../components/antd/APICascader';
import Api from '../../api';
const api = Api();
let AdminQuestionnaireFormPage = class AdminQuestionnaireFormPage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
        this.ref = React.createRef();
    }
    render() {
        return (React.createElement(AdminPage, null,
            React.createElement(Card, { title: '\u901A\u7528\u95EE\u5377', size: 'small', style: { height: '100%' } },
                React.createElement(APIForm, { ref: this.ref, action: '/admin/questionnaires', loader: '/admin/questionnaires/:id', value: this.props.id, labelCol: { span: 2 }, onRequestSucceeded: () => this.props.route.navigate(-1) }, (values) => (React.createElement(React.Fragment, null,
                    React.createElement(Form.Item, { label: '\u95EE\u5238\u6807\u9898', name: ['title'], rules: [{ required: true, message: '请输入问券标题' }], wrapperCol: { span: 8 } },
                        React.createElement(Input, { placeholder: '\u8BF7\u8F93\u5165\u95EE\u5238\u6807\u9898' })),
                    React.createElement(Form.Item, { label: '\u8BCA\u7597\u9879\u76EE', wrapperCol: { span: 8 }, name: ['path'], rules: [
                            { required: true, validator: (_, value) => {
                                    if (!value) {
                                        return Promise.reject(new Error('请正确选择医院/科室/诊疗项目'));
                                    }
                                    if (value && value.split('/').length !== 3) {
                                        return Promise.reject(new Error('请正确选择医院/科室/诊疗项目'));
                                    }
                                    return Promise.resolve();
                                } }
                        ] },
                        React.createElement(APICascader, { loader: {
                                root: '/admin/organizations/tree/:path/children?type=hospital',
                                children: '/admin/organizations/tree/:path/children',
                            }, params: {
                                path: 'root'
                            }, depth: 3, cascadeParamName: 'path', placeholder: '\u9009\u62E9\u6240\u5C5E\u533B\u9662\u3001\u79D1\u5BA4\u3001\u8BCA\u7597\u9879\u76EE', fieldNames: {
                                label: 'name',
                                value: 'id',
                                path: 'full_path'
                            } })),
                    React.createElement(Form.Item, { label: '\u95EE\u9898\u5217\u8868', name: ['question_ids'] },
                        React.createElement(APITagListSearchSelect, { loader: '/admin/questions/typeahead', tags: `/admin/questions/${this.props.id}/list`, searchParamName: 'keywords', tagFieldNames: { text: 'title' }, onChange: (value) => {
                                console.log(value);
                            } })),
                    React.createElement(Row, { justify: 'end' },
                        React.createElement(Col, null,
                            React.createElement(Space, null,
                                React.createElement(Button, { onClick: () => this.props.route.navigate(-1) }, "\u53D6\u6D88"),
                                React.createElement(Button, { type: "primary", htmlType: 'submit' }, "\u786E\u5B9A"))))))))));
    }
};
AdminQuestionnaireFormPage = __decorate([
    WithRouter({
        onBeforeEnter: (route, app) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            return {
                id: (_a = route.params) === null || _a === void 0 ? void 0 : _a.id,
            };
        })
    })
], AdminQuestionnaireFormPage);
export default AdminQuestionnaireFormPage;
